import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(
    (supabaseUrl || '') as string,
    (supabaseAnonKey || '') as string,
    {
        auth: {
            // The public site does not rely on Supabase auth sessions, but we still
            // give this client its own storage namespace so it never collides with
            // admin or translator portal clients in the same browser context.
            storageKey: 'lm-public-auth',
            // Admin auth is password-based only. Disabling URL hash detection prevents
            // the admin client from accidentally picking up a translator's access_token
            // when the confirmation link (which redirects to /portal#access_token=...)
            // is opened in the same browser as an active admin session.
            detectSessionInUrl: false,
        },
    },
);
